import { render, staticRenderFns } from "./VersionRibbon.vue?vue&type=template&id=431098ce&scoped=true&"
import script from "./VersionRibbon.vue?vue&type=script&lang=js&"
export * from "./VersionRibbon.vue?vue&type=script&lang=js&"
import style0 from "./VersionRibbon.vue?vue&type=style&index=0&id=431098ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431098ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('431098ce')) {
      api.createRecord('431098ce', component.options)
    } else {
      api.reload('431098ce', component.options)
    }
    module.hot.accept("./VersionRibbon.vue?vue&type=template&id=431098ce&scoped=true&", function () {
      api.rerender('431098ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VersionRibbon.vue"
export default component.exports